import React from 'react';
import { InfoIcon } from 'wix-rich-content-ui-components';
import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = ".pW78z{display:flex;display:grid;font-size:14px;grid-template-columns:auto max-content}.pW78z ._6-374{display:flex}";
var styles = {"container":"pW78z","tooltip":"_6-374"};
styleInject(css_248z);

const AdsenseTitle = ({ t }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.container }, t("HtmlEditPanel_HtmlInput_AdSense_Title"), /* @__PURE__ */ React.createElement("div", { className: styles.tooltip }, /* @__PURE__ */ React.createElement(InfoIcon, { tooltipText: t("HtmlEditPanel_HtmlInput_AdSense_Tooltip") })));
};

export { AdsenseTitle as default };
//# sourceMappingURL=AdsenseTitle.js.map
